import { DateTime } from "luxon";
import { getApiBaseUrl } from "../helpers/api";

// this function is used to format number with comma and unit
const numberFormat = (num, unit) => {

    const formatted = Math.abs(num).toLocaleString("en-US");

    if (unit) {
        return num < 0 ? `(-) ${formatted}${unit}` : `${formatted}${unit}`;
    }
    return num < 0 ? `(-) ${formatted}` : formatted;
};

const datetimeFormat = (date, fromFormat, toFormat) => {
    if (!date) return "";
    if (fromFormat === "ISO") {
        const result = DateTime.fromISO(date, { setZone: true }).toFormat(toFormat, { setZone: true });
        return result;
    } else {
        const result = DateTime.fromFormat(date, fromFormat, { setZone: true }).toFormat(toFormat);
        return result;
    }

}


// this function is used to split car number into front and last 4 digits
// input: "12가 1234" or "12가1234"
// output: { front: "12가", back: "1234" }
const splitCarNumber = (carNumber) => {
    if (!carNumber) return {
        front: null,
        back: null
    };

    carNumber = carNumber.replace(/\s+/g, '');
    const back = carNumber.slice(-4);
    const front = carNumber.slice(0, -4);
    return {
        front: front,
        back: back
    };
}

const replaceImageLink = (imageLink) => {
    if (process.env.NODE_ENV === 'production' && window.location.hostname?.includes('mobilesongpagongdanpark2.or.kr')) {
        imageLink = imageLink?.replaceAll("http://172.28.219.23:8080", `${getApiBaseUrl()}facility/get_image?imagePath=`);
    } else {
        imageLink = imageLink?.replaceAll("http://172.17.10.35:8899", "https://ipms8899.au.ngrok.io");
        imageLink = imageLink?.replaceAll("http://172.17.10.36:8899", "https://ipms8899.au.ngrok.io");
        imageLink = imageLink?.replaceAll("http://localhost:8080", "https://ipms8899.au.ngrok.io");
    }
    return encodeURI(imageLink);
}

function isDuplicateEntryIdAtIndex(arr, index) {
    const targetId = arr[index]?.entryId;
    if (targetId == undefined || !arr[index]?.entryId) return false;

    return arr.some((item, i) => i !== index && item.entryId == targetId);
}

// function for print form
function makeFixedLine(leftText, rightText, isBig = false) {
    const totalLength = isBig ? 24 : 48;

    const leftTextChk = leftText ?? '';
    const rightTextChk = rightText ?? '';

    const leftByteLength = getByteLength(leftTextChk);
    const rightByteLength = getByteLength(rightTextChk);
    const spaceByteLength = totalLength - (leftByteLength + rightByteLength);
    const spaces = ' '.repeat(Math.max(spaceByteLength, 0));

    return leftTextChk + spaces + rightTextChk;
}

// function for print form
function makeCenterLine(text, isBig = false) {
    const totalLength = isBig ? 24 : 48;

    const textChk = text ?? '';

    const textByteLength = getByteLength(textChk);
    const spaceByteLength = totalLength - textByteLength;

    const leftSpaces = Math.floor(spaceByteLength / 2);
    const rightSpaces = spaceByteLength - leftSpaces;

    return ' '.repeat(Math.max(leftSpaces, 0)) + textChk + ' '.repeat(Math.max(rightSpaces, 0));
}

// function for print form
function getByteLength(str) {
    if (typeof str !== 'string') {
        str = (str ?? '').toString();
    }
    let byteLength = 0;

    for (let i = 0; i < str.length; i++) {
        const code = str.charCodeAt(i);
        if (code > 0x7f) {
            byteLength += 2; // kor, symbols 2byte
        } else {
            byteLength += 1; // eng, num, etc  1byte
        }
    }
    return byteLength;
}


// function for payment card data
function maskCardNumber(cardNumb) {
    if (cardNumb) {
        const visible = cardNumb.slice(0, 6);
        const masked = "*".repeat(10);
        return visible + masked;
    } else {
        return '';
    }
}

// function for time number to text (ex, 523 => 8 hour 43 minutes)
function formatMinutesToTime(minutes) {
    if (
        minutes === null ||
        minutes === undefined ||
        isNaN(minutes) ||
        Number(minutes) < 0
    ) {
        return '0시간 0분';
    }

    const totalMinutes = Number(minutes);
    const hours = Math.floor(totalMinutes / 60);
    const mins = totalMinutes % 60;

    return `${hours}시간 ${mins}분`;
}


const getFormattedTime = (serverTime, format = 'yyyyMMddHHmmss') => {
    try {
        if (format === "ISO" && serverTime instanceof DateTime) {
            return serverTime?.toISO();
        } else if (format === "ISO") {
            return DateTime.now().setZone('Asia/Seoul').toISO();
        }
        // Check servertime and toformat
        if (serverTime && serverTime instanceof DateTime) {
            return serverTime?.toFormat(format);
        }
        // Fallback: Using the current time with ASIA/Seoul time zone
        return DateTime.now().setZone('Asia/Seoul').toFormat(format);
    } catch (error) {
        console.error('Error formatting time:', error);
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(
                JSON.stringify({ error: 'Failed to format time' })
            );
        }
        // Returns safe value
        return DateTime.now().setZone('Asia/Seoul').toFormat(format);
    }
};

async function getCompressedDataUrl(canvas, maxSizeKB = 100) {
    let quality = 0.5;
    const minQuality = 0.05;
    const step = 0.05;

    while (quality >= minQuality) {
        const dataUrl = canvas.toDataURL('image/jpeg', quality);

        const sizeInBytes = Math.round((dataUrl.length * 3) / 4);
        const sizeInKB = sizeInBytes / 1024;

        if (sizeInKB <= maxSizeKB) {
            return dataUrl;
        }

        quality -= step;
    }

    return canvas.toDataURL('image/jpeg', minQuality);
}

export { getCompressedDataUrl, getFormattedTime, numberFormat, splitCarNumber, replaceImageLink, isDuplicateEntryIdAtIndex, makeFixedLine, makeCenterLine, getByteLength, datetimeFormat, maskCardNumber, formatMinutesToTime };
